var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path10, _g9, _path11, _g10, _path12, _g11, _path13, _path14, _g12, _path15, _g13, _path16, _g14, _path17, _g15, _path18, _g16, _path19, _g17, _path20, _g18, _path21, _g19, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRejoinCallIcon = function SvgRejoinCallIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1120_3972)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 79.999C160 124.183 124.184 159.999 80 159.999C35.8163 159.999 0 124.183 0 79.999C0 35.8163 35.8163 0 80 0C124.184 0 160 35.8163 160 79.999Z",
    fill: "#50A5ED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1120_3972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 159.999H160V0H0V159.999Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1120_3972)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5834 50.1669C32.1565 50.1669 31 49.0104 31 47.5834C31 46.1565 32.1565 45 33.5834 45C35.0104 45.0004 36.1669 46.1569 36.1669 47.5834C36.1669 49.0104 35.0104 50.1669 33.5834 50.1669Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1120_3972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 159.999H160V0H0V159.999Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1120_3972)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 127C41.2383 127 39 124.762 39 122C39 119.238 41.2383 117 44 117C46.7617 117.001 49 119.239 49 122C49 124.762 46.7617 127 44 127Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1120_3972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 159.999H160V0H0V159.999Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1120_3972)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.5 96C139.567 96 138 94.4332 138 92.5C138 90.5668 139.567 89 141.5 89C143.433 89.0005 145 90.5673 145 92.5C145 94.4332 143.433 96 141.5 96Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1120_3972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 159.999H160V0H0V159.999Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1120_3972)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86816 105.715H57.3977V69.7734H8.86816V105.715Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1120_3972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 159.999H160V0H0V159.999Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1120_3972)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0806 88.9064H49.1828V86.5714H17.0806V88.9064Z",
    fill: "#999999"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1120_3972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 159.999H160V0H0V159.999Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1120_3972)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0806 84.2426H49.1828V81.9138H17.0806V84.2426Z",
    fill: "#999999"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1120_3972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 159.999H160V0H0V159.999Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1120_3972)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1313 79.584H49.1313V77.2469H17.1313V79.584Z",
    fill: "#AB5998"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1120_3972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 159.999H160V0H0V159.999Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1120_3972)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0806 93.569H49.1828V91.2382H17.0806V93.569Z",
    fill: "#999999"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1120_3972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 159.999H160V0H0V159.999Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1120_3972)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0806 98.2328H33.1311V95.902H17.0806V98.2328Z",
    fill: "#999999"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1120_3972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 159.999H160V0H0V159.999Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1120_3972)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.654 19.0963H55.3547C50.6889 19.0963 46.8613 22.9146 46.8613 27.598V132.41C46.8613 137.085 50.6889 140.902 55.3547 140.902H104.654C109.327 140.902 113.14 137.085 113.14 132.41V27.598C113.14 22.9146 109.327 19.0963 104.654 19.0963Z",
    fill: "#3776AB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1120_3972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 159.999H160V0H0V159.999Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1120_3972)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6636 122.493H108.331V37.5122H51.6636V122.493Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1120_3972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 159.999H160V0H0V159.999Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1120_3972)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1120_3972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 42,
    width: 76,
    height: 76
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M118 42H42V118H118V42Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1120_3972)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.1982 79.9999L95.9496 68.2486C97.1109 67.0893 97.1126 65.208 95.9533 64.0466C94.7939 62.8852 92.9126 62.8836 91.7512 64.0429L79.9999 75.7942L68.2486 64.0429C67.0873 62.8815 65.2043 62.8815 64.0429 64.0429C62.8815 65.2043 62.8815 67.0873 64.0429 68.2486L75.7942 79.9999L64.0429 91.7512C62.8815 92.9126 62.8815 94.7956 64.0429 95.957C65.2043 97.1184 67.0873 97.1184 68.2486 95.957L79.9999 84.2057L91.7512 95.957C92.9126 97.1184 94.7956 97.1184 95.957 95.957C97.1184 94.7956 97.1184 92.9126 95.957 91.7512L84.1982 79.9999Z",
    fill: "#DB3D49"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1120_3972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 159.999H160V0H0V159.999Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1120_3972)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7488 134.324C73.4946 134.324 72.4727 133.302 72.4727 132.039V131.356C72.4727 130.091 73.4946 129.073 74.7488 129.073H85.2551C86.5062 129.073 87.5261 130.091 87.5261 131.356V132.039C87.5261 133.302 86.5062 134.324 85.2551 134.324H74.7488Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1120_3972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 159.999H160V0H0V159.999Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1120_3972)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1442 28.2999C82.1442 29.4839 81.1893 30.4325 80.0094 30.4325C78.8306 30.4325 77.8706 29.4839 77.8706 28.2999C77.8706 27.122 78.8306 26.161 80.0094 26.161C81.1893 26.161 82.1442 27.122 82.1442 28.2999Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1120_3972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 159.999H160V0H0V159.999Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1120_3972)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.8587 28.2998C80.8587 28.7695 80.4799 29.1473 80.0092 29.1473C79.5364 29.1473 79.1514 28.7695 79.1514 28.2998C79.1514 27.8322 79.5364 27.442 80.0092 27.442C80.4799 27.442 80.8587 27.8322 80.8587 28.2998Z",
    fill: "#242D3C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1120_3972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 159.999H160V0H0V159.999Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1120_3972)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8384 44.7381H140.193V30.2865H96.8384V44.7381Z",
    fill: "#D16AB9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1120_3972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 159.999H160V0H0V159.999Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1120_3972)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.568 122.493H143.374V111.138H117.568V122.493Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1120_3972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 159.999H160V0H0V159.999Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1120_3972)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.631 54.8986H148.502V52.5677H120.631V54.8986Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1120_3972",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 159.999H160V0H0V159.999Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1120_3972)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.631 59.5572H134.566V57.2263H120.631V59.5572Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1120_3972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRejoinCallIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rejoin-call-icon.7c5fe58c.svg";
export { ForwardRef as ReactComponent };